var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-layout-header", { class: [_vm.theme, "global-header"] }, [
    _c(
      "div",
      { class: ["global-header-wide", _vm.layout] },
      [
        _vm.isMobile || _vm.layout === "head"
          ? _c(
              "router-link",
              {
                class: ["logo", _vm.isMobile ? null : "pc", _vm.theme],
                attrs: { to: "/" }
              },
              [
                _c("img", {
                  attrs: { width: "32", src: "static/img/vue-antd-logo.png" }
                }),
                _vm._v(" "),
                !_vm.isMobile
                  ? _c("h1", [_vm._v(_vm._s(_vm.systemName))])
                  : _vm._e()
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isMobile
          ? _c("a-divider", { attrs: { type: "vertical" } })
          : _vm._e(),
        _vm._v(" "),
        _vm.layout === "side"
          ? _c("a-icon", {
              staticClass: "trigger",
              attrs: { type: _vm.collapsed ? "menu-unfold" : "menu-fold" },
              on: { click: _vm.toggleCollapse }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.layout === "head"
          ? _c(
              "div",
              { staticClass: "global-header-menu" },
              [
                _c("i-menu", {
                  staticStyle: { height: "64px", "line-height": "64px" },
                  attrs: {
                    theme: _vm.theme,
                    mode: "horizontal",
                    menuData: _vm.menuData
                  },
                  on: { select: _vm.onSelect }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("header-avatar", {
          staticClass: "header-item",
          staticStyle: { float: "right" }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "userClass" },
          [
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { staticStyle: { cursor: "pointer" }, attrs: { span: 12 } },
                  [
                    _vm.authTenantData.length === 1
                      ? _c("div", [
                          _c("div", { staticClass: "textStyle" }, [
                            _c("i", { staticClass: "el-icon-s-custom" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.loginTenant.tenantName))
                            ])
                          ])
                        ])
                      : _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.authTenantData.length > 1,
                                expression: "authTenantData.length > 1"
                              }
                            ]
                          },
                          [
                            _c(
                              "el-dropdown",
                              {
                                attrs: { trigger: "click" },
                                on: { command: _vm.handleAuthTenant }
                              },
                              [
                                _c("div", { staticClass: "textStyle" }, [
                                  _c("i", { staticClass: "el-icon-s-custom" }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.loginTenant.tenantName))
                                  ]),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass:
                                      "el-icon-arrow-down el-icon--right"
                                  })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    staticStyle: {
                                      "max-height": "500px",
                                      overflow: "auto"
                                    },
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown"
                                  },
                                  _vm._l(_vm.authTenantData, function(item) {
                                    return _c(
                                      "el-dropdown-item",
                                      {
                                        key: item.tenantId,
                                        attrs: {
                                          command: item.tenantId,
                                          disabled:
                                            _vm.loginTenant.tenantId ===
                                            item.tenantId,
                                          divided: ""
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                   " +
                                            _vm._s(item.tenantName) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  { staticStyle: { cursor: "pointer" }, attrs: { span: 12 } },
                  [
                    _vm.authDepartmentData.length === 1
                      ? _c("div", [
                          _c("div", { staticClass: "textStyle" }, [
                            _c("i", { staticClass: "el-icon-s-grid" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.loginDepartment.departmentName))
                            ])
                          ])
                        ])
                      : _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.authDepartmentData.length > 1,
                                expression: "authDepartmentData.length > 1"
                              }
                            ]
                          },
                          [
                            _c(
                              "el-dropdown",
                              {
                                attrs: { trigger: "click" },
                                on: { command: _vm.handleAuthDepartment }
                              },
                              [
                                _c("div", { staticClass: "textStyle" }, [
                                  _c("i", { staticClass: "el-icon-s-grid" }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.loginDepartment.departmentName)
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass:
                                      "el-icon-arrow-down el-icon--right"
                                  })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    staticStyle: {
                                      "max-height": "500px",
                                      overflow: "auto"
                                    },
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown"
                                  },
                                  _vm._l(_vm.authDepartmentData, function(
                                    item
                                  ) {
                                    return _c(
                                      "el-dropdown-item",
                                      {
                                        key: item.departmentId,
                                        attrs: {
                                          command: item.departmentId,
                                          disabled:
                                            item.departmentId ===
                                            _vm.loginDepartment.departmentId,
                                          divided: ""
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(item.departmentName) +
                                            "\n                  "
                                        )
                                      ]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                  ]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b08024f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b08024f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/GlobalHeader.vue
// module id = null
// module chunks = 